import {
  startPhotoSession,
  fetchChecklist,
  finishChecklistSession,
} from 'api/photo-session';
import { ChecklistRepository } from 'data/ChecklistRepository';
import { UPDATE_SECTION_VISIBILITY } from 'containers/PropertyAssessment/constants';
import { selectPhotoSessionDetail } from 'containers/PhotoSessionDetail/selectors';
import { getCachedSessionPropertyAddress } from './utils/houseAddressMerge';
import {
  START_PHOTO_SESSION,
  FETCH_API_CHECKLIST_ITEMS,
  CHECKLIST_MAIN_PAGE_VIEWED_ANALYTICS,
  CHECKLIST_HOUSE_STEP_CLICKED_ANALYTICS,
  CHECKLIST_EXTERNAL_AREA_CLICKED_ANALYTICS,
  CHECKLIST_ITEM_CHANGED,
  UPDATE_STORAGE_CHECKLIST_ITEM,
  UPDATE_HOUSE_ADDRESS,
  FETCH_CHECKLIST_FROM_STORAGE,
  FINISH_CHECKLIST_ACTION,
  FINISH_CHECKLIST_CLICKED_ANALYTICS,
  FINISH_CHECKLIST_ERROR_UPDATE,
  CHECKLIST_CLEAN_STORE,
  CHECKLIST_VALID_CHANGED,
  CHECKLIST_OPEN_DIALOG_CHANGED,
  OPEN_FINISH_SESSION_DIALOG,
  CHECKLIST_GENERAL_CONDITIONS_CLICKED_ANALYTICS,
  UPDATE_CONDO_NAME,
} from './types';

export const startPhotoSessionAction = (photoSessionId) => ({
  type: START_PHOTO_SESSION,
  promise: startPhotoSession(photoSessionId),
});

export const checklistPageViewedAnalytics = ({
  photoSessionId,
  houseId,
  photographerId,
}) => ({
  type: CHECKLIST_MAIN_PAGE_VIEWED_ANALYTICS,
  extraProperties: {
    photoSessionId,
    houseId,
    photographerId,
  },
});

export const houseStepClickedAnalytics = ({ photoSessionId, houseId }) => ({
  type: CHECKLIST_HOUSE_STEP_CLICKED_ANALYTICS,
  extraProperties: {
    photoSessionId,
    houseId,
  },
});

export const externalAreaClickedAnalytics = ({ photoSessionId, houseId }) => ({
  type: CHECKLIST_EXTERNAL_AREA_CLICKED_ANALYTICS,
  extraProperties: {
    photoSessionId,
    houseId,
  },
});

export const generalConditionsClickedAnalytics = ({
  photoSessionId,
  houseId,
  houseArea,
  fullEvaluation,
}) => ({
  type: CHECKLIST_GENERAL_CONDITIONS_CLICKED_ANALYTICS,
  extraProperties: {
    photoSessionId,
    houseId,
    houseArea,
    fullEvaluation,
  },
});

export const checklistItemChanged = ({
  photoSessionId,
  sectionType,
  section,
  itemSlug,
  value,
  previousValue,
}) => (dispatch, getState) => {
  dispatch({
    type: CHECKLIST_ITEM_CHANGED,
    properties: {
      photoSessionId,
      sectionType,
      section,
      itemSlug,
      value,
      previousValue,
    },
  });

  dispatch({
    type: UPDATE_SECTION_VISIBILITY,
    payload: {
      photoSessionId,
      checklist: getState().checklist,
    },
  });
};

export const updateHouseAddressAction = ({ floor, complement, number, street, neighborhood }) => ({
  type: UPDATE_HOUSE_ADDRESS,
  extraProperties: {
    floor,
    complement,
    street,
    neighborhood,
    number,
  },
});

export const updateCondoNameAction = ({ condoName }) => ({
  type: UPDATE_CONDO_NAME,
  condoName,
});

export const updateStorageChecklistItem = ({
  sectionType,
  section,
  itemSlug,
  value,
  previousValue,
  photoSessionId,
  userId,
  editedByUser,
}) => ({
  type: UPDATE_STORAGE_CHECKLIST_ITEM,
  promise: ChecklistRepository.saveChecklistItem({
    userId,
    item: value,
    itemSlug,
    sectionSlug: section,
    photoSessionId,
    sectionType,
    editedByUser,
  }),
  meta: {
    sectionType,
    section,
    itemSlug,
    value,
    previousValue,
  },
});

export const fetchChecklistAction = () =>
  ({
    type: FETCH_API_CHECKLIST_ITEMS,
    promise: fetchChecklist(),
  });


export const fetchChecklistFromStorageAction = ({ userId, photoSessionId }) => ({
  type: FETCH_CHECKLIST_FROM_STORAGE,
  promise: ChecklistRepository.getChecklist({ userId, photoSessionId }),
});

export const finishChecklistSessionAction = ({ photoSessionId, checklist }) => (
  dispatch,
  getState,
) => dispatch({
  type: FINISH_CHECKLIST_ACTION,
  promise: finishChecklistSession({
    photoSessionId,
    checklist,
    cachedSessionProperty: getCachedSessionPropertyAddress(
      selectPhotoSessionDetail(getState()),
    ),
  }),
});

export const finishChecklistSessionOnClickAnalytics = ({ photoSessionId }) => ({
  type: FINISH_CHECKLIST_CLICKED_ANALYTICS,
  extraProperties: { photoSessionId },
});

export const finishChecklistErrorUpdate = ({ hasFinishSessionError }) => ({
  type: FINISH_CHECKLIST_ERROR_UPDATE,
  properties: { hasFinishSessionError },
});

export const cleanChecklistStore = () => ({
  type: CHECKLIST_CLEAN_STORE,
});

export const updateIsChecklistValidAction = (isValid) => ({
  type: CHECKLIST_VALID_CHANGED,
  extraProperties: isValid,
});

export const updateShouldOpenDialogAction = (shouldOpenDialog) => ({
  type: CHECKLIST_OPEN_DIALOG_CHANGED,
  extraProperties: shouldOpenDialog,
});

export const openFinishSessionDialog = () => ({
  type: OPEN_FINISH_SESSION_DIALOG,
});
